import { render, staticRenderFns } from "./TaxClassification.vue?vue&type=template&id=7c5edeff"
import script from "./TaxClassification.vue?vue&type=script&lang=js"
export * from "./TaxClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports